import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Clothing from "./pages/Clothing";
import SchoolCamps from "./pages/SchoolCamps";
import FallLeague from "./pages/FallLeague";
import GirlsCamp from "./pages/GirlsCamp";
import TrainersPage from "./pages/TrainersPage";
import TestimonialsPage from "./pages/TestimonialsPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in document.documentElement.style ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/clothing" element={<Clothing />} />
          <Route path="/school-camps" element={<SchoolCamps />} />
          <Route path="/fall-league" element={<FallLeague />} />
          <Route path="/girls-camp" element={<GirlsCamp />} />
          <Route path="/trainers" element={<TrainersPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
